class Globals {
    static defaults:any = {
        org: '',
        activeBU: '',
        user: '',
        policies: null
    }
}

export default Globals